import React from "react";
import {
  MDBBreadcrumb,
  MDBBreadcrumbItem,
  MDBContainer,
  MDBNavbar,
  MDBBtn,
  MDBIcon,
  MDBCard,
  MDBCardImage,
  MDBCardOverlay,
  MDBCardTitle,
  MDBCardText,
  MDBCardBody,
} from "mdb-react-ui-kit";
import service1 from "../images/Services_Banners/service1.webp";
import service2 from "../images/Services_Banners/service2.webp";
import service3 from "../images/Services_Banners/service3.webp";
import service4 from "../images/Services_Banners/service4.webp";
import service5 from "../images/Services_Banners/service5.webp";
import service7 from "../images/Services_Banners/service6.webp";
import "../css/service.css";
import '../css/servicehome.css';

export default function App() {
  return (
    <MDBContainer fluid className="p-0 bg-white servicetest">
      <div className="container py-5">
        <div className="row">
          <div className="row justify-content-center mt-2">
            <div className="section-heading1">
              <h1
                className="title mb-4 AcerhealthTextPurple text-center servicespace3"
                style={{ fontFamily: 'Lora, serif' }}
              >
                Services
              </h1>

              <p
                className="container para-desc mx-auto mb-0 display-9 rcmservices1"
                style={{
                  fontFamily: "Alegreya Sans",
                  fontWeight: "500",
                  lineHeight: "1.5",
                  textAlign: "justify" // <-- Justify text
                }}
              >
                At
                <a
                  href="https://acerhealth.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: "#007BFF", textDecoration: "none", margin: "0 10px" }}
                >
                AcerHealth,
                </a>
              we provide
                <a
                  href="https://acerhealth.com/services/medical-billing-services"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: "#007BFF", textDecoration: "none", margin: "0 5px" }}
                >
                  comprehensive medical billing services
                </a>
                that help healthcare practices increase profitability,
                enhance <b>patient satisfaction,</b> and improve operational efficiency. Our expert team manages every aspect of the <b>revenue cycle,</b>
                from claim submission and coding to <b>denial management</b> and payment posting, ensuring accurate billing and faster reimbursements.
              </p>

              <p
                className="container para-desc mx-auto mb-0 display-9 rcmservices1"
                style={{
                  fontFamily: "Alegreya Sans",
                  fontWeight: "500",
                  lineHeight: "1.5",
                  textAlign: "justify" // <-- Justify text
                }}
              >
                By choosing our <b>medical billing outsourcing services,</b> you reduce administrative burden, minimize claim errors, and maintain full compliance with payer and government regulations.
                Whether you're a solo provider or a multi-specialty group, our tailored solutions support scalable growth and financial stability.
              </p>

              <p
                className="container para-desc mx-auto mb-0 display-9 rcmservices1"
                style={{
                  fontFamily: "Alegreya Sans",
                  fontWeight: "500",
                  lineHeight: "1.5",
                  textAlign: "justify" // <-- Justify text
                }}
              >
                Explore our full range of <b>revenue cycle management services</b> and discover how
                AcerHealth helps you streamline billing operations while keeping patient care your top priority.
              </p>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-lg-4 col-md-12 mb-4 mb-md-4">
            <MDBCard
              className="service-wrapper"
              style={{
                position: 'relative',
              }}
              onMouseEnter={(e) => {
                const content = e.currentTarget.querySelector('.scroll-content');
                if (content) {
                  content.style.overflowY = 'auto';
                }
              }}
              onMouseLeave={(e) => {
                const content = e.currentTarget.querySelector('.scroll-content');
                if (content) {
                  content.style.overflowY = 'hidden';
                }
              }}
            >
              <MDBCardImage
                src={service1}
                alt="Comprehensive Medical Billing Services"
                position="top"
              />
              <MDBCardBody>
                <div
                  className="AcerhealthTextPurple servicespace1"
                  style={{
                    fontFamily: 'Alegreya Sans',
                    fontWeight: 'bold',
                  }}
                >
                  Comprehensive Medical Billing Services
                </div>
                <MDBCardText
                  className="servicespace2 scroll-content"
                  style={{
                    fontFamily: 'Alegreya Sans',
                    fontWeight: 500,
                    maxHeight: '150px', // Adjust as needed
                    overflowY: 'hidden',
                  }}
                >
                  Medical billing is one of the most critical yet time-consuming tasks for today’s healthcare providers. At <b>AcerHealth,</b> we offer <b>comprehensive medical billing services</b> that simplify every
                  step of the <a
                    href="https://acerhealth.com/services/revenue-cycle-management"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: '#007BFF', textDecoration: 'none', margin: '0 5px' }}
                  >
                    revenue cycle management
                  </a>
                  process. As a trusted medical billing company, we help reduce administrative burdens, minimize claim denials, and improve cash flow—so providers can focus
                  on delivering high-quality patient care. From charge entry and coding to claim submission and payment posting, our experienced team ensures accuracy, compliance, and faster reimbursements. Partner
                  with AcerHealth to streamline your billing operations and enhance your practice’s profitability.
                </MDBCardText>
              </MDBCardBody>
            </MDBCard>

          </div>

          <div className="col-lg-4 col-md-12 mb-4 mb-md-4">
            <MDBCard className="service-wrapper card-scroll">
              <MDBCardImage src={service2} alt="Credentialing Services" position="top" />
              <MDBCardBody>
                <div className="AcerhealthTextPurple servicespace1" style={{ fontFamily: 'Alegreya Sans', fontWeight: 'bold' }}>Credentialing Services</div>
                <MDBCardText className="servicespace2 scroll-content" style={{ fontFamily: "Alegreya Sans", fontWeight: '500' }}>
                  At<b> AcerHealth, </b>we offer reliable and efficient <b>provider credentialing services </b>tailored to meet the unique needs of healthcare
                  practices. Our team of experienced medical credentialing experts works closely with providers to ensure fast, accurate enrollment
                  with commercial insurers and government payers. With a deep understanding of payer requirements and compliance standards, we deliver
                  credentialing solutions that seamlessly integrate into your workflow.
                  <p style={{ fontFamily: "Alegreya Sans", fontWeight: '500' }} >
                    Having successfully completed credentialing services for over 300 healthcare providers, AcerHealth is a trusted partner for clinics, group practices, and solo practitioners.
                    Let us handle the paperwork and deadlines while you focus on patient care.

                  </p>

                </MDBCardText>
              </MDBCardBody>
            </MDBCard>
          </div>

          <div className="col-lg-4 col-md-12 mb-4 mb-md-4">
            <MDBCard className="service-wrapper card-scroll">
              <MDBCardImage src={service3} alt="Credentialing Services" position="top" />
              <MDBCardBody>
                <div className="AcerhealthTextPurple servicespace1" style={{ fontFamily: 'Alegreya Sans', fontWeight: 'bold' }}>Set Up a Practice</div>
                <MDBCardText className="servicespace2 scroll-content" style={{ fontFamily: "Alegreya Sans", fontWeight: '500' }}>
                  Starting a new medical practice? <b>AcerHealth </b>provides end-to-end support for providers looking to launch solo or group practices. Our team specializes in managing
                  the operational and administrative tasks that often overwhelm new providers—from <b>credentialing and billing setup</b> to EMR integration and insurance enrollment.
                  <p style={{ fontFamily: "Alegreya Sans", fontWeight: '500' }}>
                    With our <b>affordable medical billing services </b>and <b>revenue cycle outsourcing solutions,</b> you can focus on patient care while we handle the backend. We’ve helped numerous providers establish
                    efficient workflows, maintain compliance, and start generating revenue faster. Whether you’re launching a clinic or moving away from hospital operations, we simplify
                    <a
                      href="https://acerhealth.com/blog/medical-billing-services-for-small-practices"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ color: "#007BFF", textDecoration: "none", margin: "0 5px" }}
                    >
                      medical billing for small practices—
                    </a>

                    offering scalable solutions that grow with you and take the stress out of your revenue cycle.

                  </p>
                </MDBCardText>
              </MDBCardBody>
            </MDBCard>
          </div>
          <div className="col-lg-4 col-md-12 mb-4 mb-md-4">
            <MDBCard className="service-wrapper card-scroll">
              <MDBCardImage src={service7} alt="Pre-Authorization Assistance" position="top" />
              <MDBCardBody>
                <div className="AcerhealthTextPurple servicespace1" style={{ fontFamily: 'Alegreya Sans', fontWeight: 'bold' }}>Pre-Authorization Assistance</div>
                <MDBCardText className="servicespace2 scroll-content" style={{ fontFamily: "Alegreya Sans", fontWeight: '500' }}>
                  At<b> AcerHealth,</b> our <b> pre-authorization assistance services </b>help healthcare providers reduce delays and improve revenue flow. We coordinate with insurance
                  companies to obtain required approvals before procedures, ensuring smoother operations and fewer claim denials. As part of our <b>affordable medical billing services, </b>
                  this support reduces administrative work and speeds up reimbursements. Whether you're a solo provider or a growing clinic, our solutions are tailored to your needs.
                  By streamlining this critical step in the billing process, we help practices maintain compliance and focus on patient care. Trust AcerHealth—your partner for efficient, reliable
                  <a
                    href="https://acerhealth.com/services/revenue-cycle-management"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: "#007BFF", textDecoration: "none", margin: "0 5px" }}
                  >
                    revenue cycle management.
                  </a>

                </MDBCardText>
              </MDBCardBody>
            </MDBCard>
          </div>
          <div className="col-lg-4 col-md-12 mb-4 mb-md-4">

            <MDBCard
              className="service-wrapper"
              style={{
                position: 'relative',
              }}
              onMouseEnter={(e) => {
                const content = e.currentTarget.querySelector('.scroll-content');
                if (content) {
                  content.style.overflowY = 'auto';
                }
              }}
              onMouseLeave={(e) => {
                const content = e.currentTarget.querySelector('.scroll-content');
                if (content) {
                  content.style.overflowY = 'hidden';
                }
              }}
            >
              <MDBCardImage
                src={service4}
                alt="Comprehensive Medical Billing Services"
                position="top"
              />
              <MDBCardBody>
               <div
                  className="AcerhealthTextPurple servicespace1"
                  style={{
                    fontFamily: 'Alegreya Sans',
                    fontWeight: 'bold',
                  }}
                >
                  Provider Credential Maintenance
                </div>
                <MDBCardText
                  className="servicespace2 scroll-content"
                  style={{
                    fontFamily: 'Alegreya Sans',
                    fontWeight: 500,
                    maxHeight: '150px', // Adjust as needed
                    overflowY: 'hidden',
                  }}
                >
                  Stay compliant with AcerHealth’s reliable <b>provider </b> <a
                    href="https://acerhealth.com/services/medical-billing-and-credentialing"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: '#007BFF', textDecoration: 'none', margin: '0 5px' }}
                  >
                    credentialing services.
                  </a>
                  We manage ongoing <b>credential maintenance </b>to keep your records current with commercial insurers
                  and government payers. Our experts handle renewals, updates, and deadlines—so you can avoid disruptions and focus on patient care.
                  As part of our <b>affordable medical billing services,</b> this ensures accuracy, compliance, and continuity. Trust one of the leading 
                  <b>medical billing companies with transparent pricing </b>to keep your credentials up to date.
                </MDBCardText>
              </MDBCardBody>
            </MDBCard>
          </div>

          <div className="col-lg-4 col-md-12 mb-md-4">
          <MDBCard className="service-wrapper card-scroll">
              <MDBCardImage src={service5} alt="MIPS Attestation" position="top" />
              <MDBCardBody>
                <div className="AcerhealthTextPurple servicespace1" style={{ fontFamily: 'Alegreya Sans', fontWeight: 'bold' }}>MIPS Attestation</div>
                <MDBCardText className="servicespace2 scroll-content" style={{ fontFamily: "Alegreya Sans", fontWeight: '500' }}>
                Optimize Medicare reimbursements and avoid penalties with AcerHealth’s expert <b>MIPS attestation support. </b>Our team guides you through every step of the
                 process to ensure accurate reporting and maximum incentive payments. As part of our <b>RCM services with billing and credentialing, </b>we help practices stay 
                 compliant and financially strong. Trust a leader among <b>top RCM vendors in the USA</b> to simplify MIPS and support your success with <b>affordable medical billing services.</b>
                </MDBCardText>
              </MDBCardBody>
            </MDBCard>
          </div>

        </div>
      </div>
    </MDBContainer>
  );
}
